<template>
  <div class="facility-form">
    <b-card>
      <template #header>
        <h2 class="mb-0">{{ isEdit ? $t('facilities.edit_title') : $t('facilities.create_title') }}</h2>
      </template>
      <b-form @submit.prevent="handleSubmit" :validated="validated" novalidate>
        <b-form-group
          :label="$t('facilities.form.name_label')"
          label-for="name"
          :state="!hasError('name')"
          :invalid-feedback="getError('name')"
        >
          <b-form-input
            id="name"
            v-model="formFields.name"
            :state="!hasError('name')"
            required
            @input="removeError('name')"
          ></b-form-input>
        </b-form-group>
        
        <div class="d-flex gap-2 mt-4">
          <b-button type="submit" variant="primary" :disabled="isSubmitting">
            <b-spinner small v-if="isSubmitting" class="mr-1"></b-spinner>
            {{ isSubmitting ? $t('common.saving') : $t('common.save') }}
          </b-button>
          <b-button variant="secondary" @click="cancel">{{ $t('common.cancel') }}</b-button>
        </div>
        <div v-if="formLevelError" class="mt-3">
          <b-alert show variant="danger" class="mb-0">
            {{ formLevelError }}
          </b-alert>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import NotifyMixin from "@/Util/NotifyMixin";

export default {
  name: "FacilityForm",
  mixins: [NotifyMixin],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
      validated: false,
      formErrors: {},
      formLevelError: "",
      formFields: {
        name: "",
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.id;
    },
  },
  methods: {
    hasError(field) {
      return !!this.formErrors[field];
    },
    getError(field) {
      return this.formErrors[field] ? this.formErrors[field][0] : "";
    },
    removeError(field) {
      if (this.formErrors[field]) {
        delete this.formErrors[field];
      }
      this.formLevelError = "";
    },
    async fetchFacility() {
      try {
        const response = await request({
          method: "get",
          url: `/facilities/${this.id}`,
        });
        this.formFields = {
          ...this.formFields,
          ...response.data,
        };
      } catch (error) {
        this.formLevelError = error.response?.data?.message || this.$t("facilities.fetch_error");
        this.notifyError(this.formLevelError);
        this.$router.push("/admin/facilities");
      }
    },
    async handleSubmit() {
      try {
        this.validated = true;
        this.isSubmitting = true;
        this.formErrors = {};
        this.formLevelError = "";
        if (!this.formFields.name.trim()) {
          this.formErrors.name = [this.$t("facilities.validation.name_required")];
        }
        if (Object.keys(this.formErrors).length > 0) {
          throw new Error("Validation failed");
        }
        await request({
          method: this.isEdit ? "put" : "post",
          url: this.isEdit ? `/facilities/${this.id}` : "/facilities",
          data: this.formFields,
        });
        this.notifySuccess(
          this.isEdit ? this.$t("facilities.update_success") : this.$t("facilities.create_success")
        );
        this.$router.push("/admin/facilities");
      } catch (error) {
        if (error.status === 422) {
          this.formErrors = error.data.message || {};
          this.formLevelError = this.formErrors;
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    cancel() {
      this.$router.push("/admin/facilities");
    },
  },
  created() {
    if (this.isEdit) {
      this.fetchFacility();
    }
  },
};
</script>

<style scoped>
.facility-form {
  padding: 20px;
}
</style> 